var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Passwordview",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.586,
    height: 15.67,
    viewBox: "0 0 24.586 15.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 24.586,
    height: 15.67,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M12.293,15.67C5.609,15.67.376,8.614.156,8.313a.811.811,0,0,1,0-.957C.376,7.056,5.609,0,12.293,0S24.21,7.056,24.43,7.357a.81.81,0,0,1,0,.957c-.22.3-5.453,7.357-12.137,7.357M1.843,7.834c1.262,1.531,5.526,6.214,10.45,6.214s9.189-4.681,10.45-6.213C21.48,6.3,17.216,1.621,12.293,1.621S3.1,6.3,1.843,7.834",
    transform: "translate(0)",
    fill: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M159.585,71.617a4.863,4.863,0,1,1,4.863-4.863,4.869,4.869,0,0,1-4.863,4.863m0-8.105a3.242,3.242,0,1,0,3.242,3.242,3.246,3.246,0,0,0-3.242-3.242",
    transform: "translate(-147.292 -58.919)",
    fill: "#6b6b6b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.48b50b73634aecc5d3cda121f9c53e28.svg";
export { ForwardRef as ReactComponent };